"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const subsOrderTypeService_1 = require("./services/subsOrderTypeService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("subscriptionPurchaseOrderType/fetch", (thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const subscriptionTypeService = new subsOrderTypeService_1.SubscriptionOrderType(Env_1.APIPATHENV);
        const response = yield subscriptionTypeService.getSubscriptionOrderTypeList();
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("subscriptionPurchaseOrderType/create", (subscriptionOrderTypeData, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const subscriptionTypeService = new subsOrderTypeService_1.SubscriptionOrderType(Env_1.APIPATHENV);
        const response = yield subscriptionTypeService.createSubscriptionOrderType(subscriptionOrderTypeData);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
